var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',{staticClass:"cargo-data-row"},[_c('b-col',{attrs:{"sm":"12","md":"5"}},[_c('label',[_vm._v(_vm._s(this.label))])]),_c('b-col',{attrs:{"sm":"12","md":"6"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.getFormattedValue)}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }